import jQuery from 'jquery'
window.$ = jQuery
window.jQuery = jQuery

import 'bootstrap/dist/css/bootstrap.css'
import 'quill/dist/quill.snow.css'

import _ from 'lodash'
window._ = _

import 'bootstrap/dist/js/bootstrap'

import swal from 'sweetalert'
window.swal = swal

import toastr from 'toastr'
import 'toastr/build/toastr.css'
window.toastr = toastr

// @ts-ignore
import 'Select2'
import 'Select2/select2.css'
import 'Select2/select2-bootstrap.css'

import moment from 'moment'
import 'moment-timezone'
window.moment = moment

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

import angular from 'angular'
import 'angular-ui-router'
import 'angular-animate'
import 'angular-cookies'
import 'angular-sanitize'
import 'angular-ui-bootstrap'
import 'angular-bootstrap-lightbox'
import 'angular-bootstrap-colorpicker'
import 'angular-bootstrap-colorpicker/css/colorpicker.css'
import 'sortablejs'
import 'angular-legacy-sortablejs-maintained'
import 'angular-select2'
import 'ng-file-upload'
import 'ng-infinite-scroll'
import 'angular-bootstrap-switch'
import 'angular-bindonce'
import 'angular-loading-bar'
import 'angular-utils-pagination'
import 'bootstrap-ui-datetime-picker'
import 'angular-input-masks'
import 'angular-timer'
import 'angular-loading-bar'
import 'angular-loading-bar/build/loading-bar.css'
import 'sweetalert/dist/sweetalert.css'
import './globals.css'
import './index.scss'

import 'ngreact'

import AppConfig from './app.config'
import AppRouter from './app.router'
import AppRun from './app.run'
import AppFilter from './app.filter'

import './admin/index'
import './publisher/index'
import './signup/signup.controller'
import './signup/signup.service'
import './signin/signin.controller'
import './signin/signin.service'
import './index.controller'

// Factory
import UserCache from './services/userCache'
import WhitelabelService from './services/whitelabel'
import AuthorizationInterceptor from './services/authorizationInterceptor'
import CacheService from './components/cache/cache'
import CsvService from './components/csv/csv'
import TranslatorService from './components/translator/translator'
import UploadService from './components/upload/upload'

// Directive
import AffiliateSelect from './components/affiliateSelect/affiliateSelect'
import Breadcrumb from './components/breadcrumb/breadcrumb'
import BreadProgress from './components/breadProgress/breadProgress'
import BreadChannel from './components/breadChannel/breadChannel'
import BreadProgressMega from './components/breadProgressMega/breadProgressMega'
import BundleSelect from './components/bundleSelect/bundleSelect'
import ChecklistSelect from './components/checklistSelect/checklistSelect'
import CouponSelect from './components/couponSelect/couponSelect'
import DatetimePicker from './components/datetimepicker/datetimepicker'
import File from './components/file/file.directive'
import Focus from './components/focus/focus.directive'
import FormatDate from './components/fomatDate/fomatDate'
import ImageLoad from './components/imageload/imageload.directive'
import Loading from './components/loading/loading'
import Modal from './components/modal/modal'
import Preview from './components/preview/preview'
import CollectibleSelect from './components/collectibleSelect/collectibleSelect'
import ShinySelect from './components/shinySelect/shinySelect'
import SegmentSelect from './components/segmentSelect/segmentSelect'
import SetSelect from './components/setSelect/setSelect'
import TagSelect from './components/tagSelect/tagSelect'

angular
  .module('collectibleApp', [
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ui.router',
    'ui.bootstrap',
    'bootstrapLightbox',
    'colorpicker.module',
    'ng-sortable',
    'collectibleApp.admin',
    'collectibleApp.pub',
    'signup',
    'signin',
    'index',
    'rt.select2',
    'ngFileUpload',
    'infinite-scroll',
    'frapontillo.bootstrap-switch',
    'pasvaz.bindonce',
    'angular-loading-bar',
    'react',
    'angularUtils.directives.dirPagination',
    'ui.bootstrap.datetimepicker',
    'ui.utils.masks',
    'timer',
  ])
  .constant('API', {
    API_URL: process.env.API_URL,
    API_URL_RPC: process.env.API_URL_RPC,
    AWS_KEY: process.env.AWS_KEY,
    AWS_SECRET: process.env.AWS_SECRET,
    QP2_ASSETS_BUCKET: process.env.QP2_ASSETS_BUCKET,
    QP2_UPLOAD_ASSETS_BUCKET: process.env.QP2_UPLOAD_ASSETS_BUCKET,
    QP2_SERVER_BUCKET: process.env.QP2_SERVER_BUCKET,
    AWS_REGION: process.env.AWS_REGION,
    AWS_DISTRIBUTION: process.env.AWS_DISTRIBUTION,
    QP2_VERSION: process.env.QP2_VERSION,
    QP2_ENV: process.env.QP2_ENV,
    MOD_TOOLS: process.env.MOD_TOOLS,
    TRANSLATOR_API: process.env.TRANSLATOR_API,
  })
  .run(AppRun)
  .config(AppRouter)
  .config(AppConfig)

  .filter(AppFilter)

  .service('UserCache', UserCache)
  .service('WhitelabelService', WhitelabelService)
  .factory('AuthorizationInterceptor', AuthorizationInterceptor)
  .factory('CacheService', CacheService)
  .factory('CsvService', CsvService)
  .factory('TranslatorService', TranslatorService)
  .factory('UploadService', UploadService)

  .directive('affiliateSelect', AffiliateSelect)
  .directive('breadcrumb', Breadcrumb)
  .directive('breadProgress', BreadProgress)
  .directive('breadChannel', BreadChannel)
  .directive('breadProgressMega', BreadProgressMega)
  .directive('bundleSelect', BundleSelect)
  .directive('checklistSelect', ChecklistSelect)
  .directive('couponSelect', CouponSelect)
  .directive('datetimepicker', DatetimePicker)
  .directive('file', File)
  .directive('autoFocus', Focus)
  .directive('formatDate', FormatDate)
  .directive('imageonload', ImageLoad)
  .directive('loading', Loading)
  .directive('modal', Modal)
  .directive('preview', Preview)
  .directive('collectibleSelect', CollectibleSelect)
  .directive('shinySelect', ShinySelect)
  .directive('segmentSelect', SegmentSelect)
  .directive('setSelect', SetSelect)
  .directive('tagSelect', TagSelect)
